import { getRandomIntInclusive } from '@application/utils';
import {
  CardItem,
  CardItemLitter,
  Container,
  HeaderProfile,
  Section,
  SideLayoutContentWrapper,
  SideLayoutSideWrapper,
  SideLayoutWrapper,
  SkeletonBox
} from '@presentation/components';
import type { FC } from 'react';
import * as RootStyled from '../../styled';
import * as Styled from './styled';
import type { PageSkeletonProps } from './types';

export const PageSkeleton: FC<PageSkeletonProps> = (props) => {
  const { backLink } = props;

  return (
    <>
      <HeaderProfile
        title={<SkeletonBox style={{ width: '20%', height: '30px' }} />}
        backLink={backLink}
      />
      <Container>
        <SideLayoutWrapper>
          <SideLayoutContentWrapper>
            <Styled.SlideshowSkeletonContainer>
              <Styled.SlideshowSkeletonMainWrapper>
                <Styled.SlideshowSkeletonMain />
              </Styled.SlideshowSkeletonMainWrapper>
            </Styled.SlideshowSkeletonContainer>

            <RootStyled.SectionWithMargin topMargin>
              <CardItem
                loading
                content={{
                  title: (
                    <SkeletonBox
                      style={{
                        width: `${getRandomIntInclusive(60, 80)}%`,
                        height: 21.5,
                        display: 'block',
                        marginBottom: 10,
                      }}
                    />
                  ),
                  text: (
                    <SkeletonBox
                      style={{
                        width: `${getRandomIntInclusive(60, 80)}%`,
                        height: 21.5,
                        display: 'block',
                        marginBottom: 10,
                      }}
                    />
                  ),
                }}
              />
            </RootStyled.SectionWithMargin>

            <Section style={{ margin: '20' }}>
              <CardItem
                loading
                content={{
                  title: (
                    <SkeletonBox
                      style={{
                        width: `${getRandomIntInclusive(60, 80)}%`,
                        height: 21.5,
                        display: 'block',
                        marginBottom: 10,
                      }}
                    />
                  ),
                  subtitle: (
                    <SkeletonBox
                      style={{
                        width: `${getRandomIntInclusive(60, 80)}%`,
                        height: 21.5,
                        display: 'block',
                        marginBottom: 10,
                      }}
                    />
                  ),
                  text: (
                    <SkeletonBox
                      style={{
                        width: `${getRandomIntInclusive(60, 80)}%`,
                        height: 21.5,
                        display: 'block',
                        marginBottom: 10,
                      }}
                    />
                  ),
                }}
              />
            </Section>

            <Section style={{ margin: '20' }}>
              <CardItem
                loading
                content={{
                  title: (
                    <SkeletonBox
                      style={{
                        width: `${getRandomIntInclusive(60, 80)}%`,
                        height: 21.5,
                        display: 'block',
                        marginBottom: 10,
                      }}
                    />
                  ),
                  subtitle: (
                    <SkeletonBox
                      style={{
                        width: `${getRandomIntInclusive(60, 80)}%`,
                        height: 21.5,
                        display: 'block',
                        marginBottom: 10,
                      }}
                    />
                  ),
                  text: (
                    <SkeletonBox
                      style={{
                        width: `${getRandomIntInclusive(60, 80)}%`,
                        height: 21.5,
                        display: 'block',
                        marginBottom: 10,
                      }}
                    />
                  ),
                }}
              />
            </Section>

            <Section style={{ margin: '20' }}>
              <RootStyled.CardItemContainer>
                <CardItemLitter style={{ height: 327.5 }} loading breed="" price="" location="" />
              </RootStyled.CardItemContainer>
            </Section>
          </SideLayoutContentWrapper>

          <SideLayoutSideWrapper>
            <Styled.SideLayoutStickyWrapper>
              <SkeletonBox
                style={{ width: `${getRandomIntInclusive(90, 100)}%`, height: '300px' }}
              />
            </Styled.SideLayoutStickyWrapper>
          </SideLayoutSideWrapper>
        </SideLayoutWrapper>
      </Container>
    </>
  );
};
